<!--

 -->

<template>
  <oxd-dialog class="gsl-hrm-dialog-popup" @update:show="onClose">
    <div class="gsl-hrm-modal-header">
      <oxd-text type="card-title">{{ $t('pim.import_details') }}</oxd-text>
    </div>
    <div class="gsl-hrm-text-center-align">
      <oxd-text
        type="card-body"
        :class="{
          'gsl-hrm-success-message': data.success > 0,
        }"
      >
        {{ $t('pim.n_records_successfully_imported', {count: data.success}) }}
      </oxd-text>
      <template v-if="data.failed > 0">
        <oxd-text type="card-body" class="gsl-hrm-error-message">
          {{ $t('pim.n_records_failed_to_import', {count: data.failed}) }}
        </oxd-text>
        <oxd-text type="card-body" class="gsl-hrm-error-message">
          {{ $t('pim.failed_rows') }}
        </oxd-text>
        <oxd-text type="card-body" class="gsl-hrm-error-message">
          {{ data.failedRows.toString() }}
        </oxd-text>
      </template>
    </div>
    <div class="gsl-hrm-modal-footer">
      <oxd-button
        display-type="text"
        :label="$t('general.ok')"
        @click="onClose"
      />
    </div>
  </oxd-dialog>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';

export default {
  name: 'EmployeeDataImportModal',
  components: {
    'oxd-dialog': OxdDialog,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  methods: {
    onClose() {
      this.$emit('close', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-modal-header {
  display: flex;
  margin-bottom: 1.2rem;
  justify-content: center;
}
.gsl-hrm-modal-footer {
  display: flex;
  margin-top: 1.2rem;
  justify-content: center;
}
.gsl-hrm-text-center-align {
  text-align: center;
  overflow-wrap: break-word;
}
::v-deep(.gsl-hrm-dialog-popup) {
  width: 450px;
}
.gsl-hrm-success-message {
  color: $oxd-feedback-success-color;
}
.gsl-hrm-error-message {
  color: $oxd-feedback-danger-color;
}
</style>
